import { styled } from "@mui/material";

export const StyledError = styled('div')(({ theme }) => ({
	fontWeight: 500,
	fontSize: 14,
	display: 'grid',
	justifyContent: 'center',
	color: theme.palette.error.light
}))
